import { type UsePreFilteredExtensionsQueryOptions } from '@atlassian/forge-ui/provider';

import { getAGGClient } from '@confluence/graphql/entry-points/getAGGClient.ts';

export const getUsePrefilteredExtensionListOptions = ({
	cloudId,
	locale,
	moduleType,
	queryOptions,
	includeHidden,
	spaceKey,
	contentId,
	spaceContextOnly = false,
}) => {
	const options: UsePreFilteredExtensionsQueryOptions = {
		client: getAGGClient(),
		cloudId,
		types: [moduleType],
		queryOptions: {
			...queryOptions,
		},
		locale,
		context: spaceContextOnly ? { spaceKey } : { spaceKey, contentId },
		includeHidden,
	};

	return options;
};
